<template>
    <div>
        <img class="user-poster" src="../../assets/images/bg.jpg"/>
        <!--<div style="background: url(/grt.png) no-repeat;background-size:100% 100%;width:100%;height:200px; display: flex;text-align: center;">
            <p style="margin:35% auto; color: ghostwhite;">{{userName}}</p>
        </div>-->
        <div class="username" style="position:relative;text-align: center;color: #fff;font-weight: 800">
            <div v-text="userName"></div>
        </div>

        <van-row class="user-links">
            <van-col span="6">
                <div style="margin: auto; width: 36px">
                    <van-icon name="paid" @click="go('/order-list?active=SUBMIT')" :info="ordersNum[1]"/>
                    待付款
                </div>
            </van-col>

            <van-col span="6">
                <div style="margin: auto; width: 36px">
                    <van-icon name="peer-pay" @click="go('/order-list?active=WITHHOLD_DEDUCTION')" :info="ordersNum[2]"/>
                    待扣款
                </div>
            </van-col>
            <van-col span="6">
                <div style="margin: auto; width: 36px">
                    <van-icon name="cash-back-record" @click="go('/order-list?active=PAID')"
                              :info="ordersNum[3]"/>
                    已付款
                </div>
            </van-col>
            <van-col span="6">
                <div style="margin: auto; width: 36px">
                    <van-icon name="passed" @click="go('/order-list?active=FINISH')" :info="ordersNum[4]"/>
                    已完成
                </div>
            </van-col>
        </van-row>
      <template v-if="!(bus.state.ops&&bus.state.ops.filter(ops=>ops==='OP_DISABLED_VIEW_MY_JYJ').length>0)">
        <van-cell-group class="user-group">
            <van-cell icon="description" title="我的订单" is-link @click="go('/order-list')"/>

            <van-cell icon="location-o" title="收货地址" is-link @click="go('address')"/>

            <van-cell v-if="!(bus.state.ops&&bus.state.ops.filter(ops=>ops==='OP_DISABLED_SUBMIT_ORDER').length>0)" icon="shopping-cart-o" title="分货直购" is-link @click="go('direct-purchase')"/>

        </van-cell-group>
        <van-cell-group class="user-group" >

            <van-cell icon="pending-payment" title="余额" :value="totalBalance" is-link @click="go('balance')"/>
            <van-cell icon="balance-list-o" title="账单" is-link @click="go('bills')"/>
            <van-cell icon="chat-o" title="消息通知" is-link @click="go('notices')"/>
            <van-cell icon="idcard" title="我的银行卡" is-link @click="go('ql-bank-card')"/>
            <van-cell icon="idcard" title="收款账号" is-link @click="go('collection_banking')"/>
            <van-cell icon="clock-o" title="开启自动扣款">
                <van-switch v-model="checked" size="20px" @change="openAutomaticDeduction"/>
            </van-cell>

        </van-cell-group>
      </template>
        <van-button size="large" class="tabbar-user__quit" @click="go('/logout')">退出当前账户</van-button>
    </div>
</template>

<script>
    import {openAutomaticDeduction, initEnableWithholding} from '../../api/pay'
    import {getBalanceInfo} from '../../api/balance'
    import bus from '../../bus'
    export default {
        data() {
          console.log( bus.state.ordersNum)
            return {
                ordersNum: bus.state.ordersNum? bus.state.ordersNum:[0,0,0,0,0],
                totalBalance: undefined,
                userName: bus.state.username,
                checked: bus.state.enableWithholding,
                disabledMyJyj:true,
                bus
            }
        },
        mounted() {
            getBalanceInfo(data => {
                this.totalBalance = (data.map(d => {
                    if (d.totalBalance) {
                        d.totalBalance = parseFloat(d.totalBalance);
                    }
                    return d.totalBalance;
                }).reduce((prev, curr) => prev + curr) / 100).toFixed(2) + '元'

            })
        },

        methods: {
            go(path) {
                this.$router.push(path);
            },

            //开启自动扣款
            openAutomaticDeduction() {
                openAutomaticDeduction(this.checked, initEnableWithholding);
            }
        }
    }
</script>

<style lang="less" scoped>
    body {
        background: #fafafa;
    }

    .user {
        background: #eee;

        &-poster {
            width: 7.5rem;
            height: 4rem;
            display: block;
        }

        &-group {
            margin-bottom: .3rem;

        }
        &-links {
            padding: 15px 0;
            font-size: 12px;
            text-align: center;
            background-color: #fff;
            .van-icon {
                display: block;
                font-size: 24px;
            }
        }
    }

    .tabbar-user__quit {
        /*position: fixed;*/
        /*bottom: 3rem;*/
        /*z-index: 2;*/
        margin-bottom: 3.2rem;
    }

    .van-switch--on {
        background-color: #fe616c;
    }

    @media screen and (max-width: 360px) {
        .username {
            top: -58px;
        }
    }

    @media screen and (max-width: 760px) {
        .username {
            top: -70px;
        }
    }

    @media screen and (min-width: 760px) {
        .username {
            top: -100px;
        }
    }
</style>
